import PushOption from "components/TeamRun/PushOption";
import UpdateOption from "components/TeamRun/UpdateOption";

/** The same trader / already-on-Team-Run popup the Pricer opens after push-check. */
export function QuickAddTeamRunPopup({ popup, onClose }) {
  if (!popup) return null;

  if (popup.kind === "update") {
    return (
      <UpdateOption
        isOpen
        onClose={onClose}
        data={popup.data}
        quantity={popup.quantity}
        summaryId={popup.summaryId}
        colors={popup.colors}
        trader={popup.tradingCompanies}
        productId={popup.productId}
        agreedDeltas={popup.agreedDeltas}
      />
    );
  }

  if (popup.kind === "push") {
    return (
      <PushOption
        isOpen
        onClose={onClose}
        data={popup.data}
        quantity={popup.quantity}
        summaryId={popup.summaryId}
        tradingCompanies={popup.tradingCompanies}
        productId={popup.productId}
      />
    );
  }

  return null;
}
